import fetch from 'unfetch'
import store from 'app/store'
import Alert from 'react-s-alert'
import { route } from 'preact-router'
import { initialState } from '../store'

const env = process.env.NODE_ENV

const baseUrl =
  env === 'development' ? 'http://localhost:3003/v1' : 'https://manter-api.herokuapp.com/v1'

async function request(url, body, method) {
  const expiration = store.getState().auth.expiration

  // Reset token
  if (expiration && new Date() > new Date(expiration)) {
    const refreshToken = store.getState().auth.refreshToken

    const res = await fetch(`${baseUrl}/auth/session`, {
      method: 'POST',
      body: JSON.stringify({ refreshToken }),
    })

    if (!res.ok) {
      store.setState(initialState)
      route('/login', true)
    }

    const result = await res.json()

    store.setState({
      auth: {
        accessToken: result.accessToken,
        refreshToken: result.refreshToken,
        expiration: result.expiration,
      },
    })
  }

  const accessToken = store.getState().auth.accessToken || null

  const headers = {
    'Content-Type': 'application/json',
  }

  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  const options = {
    method,
    headers,
  }

  if (method !== 'GET' && method !== 'HEAD') {
    options.body = JSON.stringify(body)
  }

  const response = await fetch(`${baseUrl}${url}`, options)

  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    const message = data.message || 'Something went wrong :('
    console.log(response)

    if (response.status !== 401) {
      Alert.error(message, {
        position: 'bottom-right',
      })
    }

    throw new Error(message)
  } else {
    return response.json().catch(() => ({}))
  }
}

export const api = {
  get: url => request(url, null, 'GET'),
  del: url => request(url, {}, 'DELETE'),
  put: (url, data) => request(url, data, 'PUT'),
  patch: (url, data) => request(url, data, 'PATCH'),
  post: (url, data) => request(url, data, 'POST'),
}



// WEBPACK FOOTER //
// ./util/api.js